import { deepFreeze } from 'utils/deepFreeze';
import { BannersState } from '.';

const initialState: Readonly<BannersState> = deepFreeze({
  byCategory: {},
  bySearchTerm: {},
  offers: {
    hotspots: [],
    leaderboards: [],
  },
});

export default initialState;
